import React from 'react';
import { WHY_CENTURION } from '../data/copy';

export const WhyCenturion = () => (
    <section
        className="mx-auto max-w-7xl px-6 py-20 md:px-10 md:py-28"
        data-testid="why-centurion"
    >
        <span className="eyebrow">Why Centurion</span>
        <h2 className="h-display mt-6 max-w-3xl text-3xl sm:text-4xl">
            {'What\u2019s on the spec sheet, in three lines.'}
        </h2>
        <div className="mt-12 grid gap-px bg-brand-hairline md:grid-cols-3">
            {WHY_CENTURION.map((w, i) => (
                <div
                    key={w.title}
                    className="bg-brand-base p-8 md:p-10"
                >
                    <span className="font-display text-xs font-bold tabular-nums tracking-[0.18em] text-brand-gold">
                        0{i + 1}
                    </span>
                    <h3 className="mt-5 font-display text-xl font-bold uppercase tracking-tight text-brand-text">
                        {w.title}
                    </h3>
                    <p className="mt-4 font-sans text-base leading-relaxed text-brand-muted">
                        {w.body}
                    </p>
                </div>
            ))}
        </div>
    </section>
);

export default WhyCenturion;
